﻿import { queries } from "@/graphql";
import { useEffect } from "react";
import { useLazyQuery } from "@apollo/client/react";
import { getOr } from "lodash/fp";
type DashboardProps = {
  customers: string | null;
  addresses: string | null;
  fromDate: string | null;
  toDate: string | null;
  resolution: string | null;
  sourceType: string | null;
  dateFrom?: string | null;
  dateTo?: string | null;
};

export const useDashboard = (props: DashboardProps) => {
  const {
    customers,
    addresses,
    fromDate,
    toDate,
    resolution,
    sourceType,
    dateFrom,
    dateTo,
  } = props;

  // const [data, setData] = useState(null);

  const [
    fetchDashboardData,
    { data: dashboardData, loading, refetch: reFetchDashboardData },
  ] = useLazyQuery<any, any>(queries.getWaterQuery, {
    // @ts-ignore
    // @ts-expect-error
    variables: {
      meterType: sourceType,
      meteringPointId: "all",
      address: addresses,
      customer: customers,
      fromDate: fromDate,
      toDate: toDate,
      resolution: resolution,
      fileType: "excel",
    },
  });

  const data = !loading ? getOr(null, "metersData", dashboardData) || "" : null;

  useEffect(() => {
    if (customers && addresses && fromDate && toDate) {
      fetchDashboardData();
      reFetchDashboardData();
    }
  }, [
    fetchDashboardData,
    reFetchDashboardData,
    customers,
    addresses,
    dateFrom,
    dateTo,
    sourceType,
    fromDate,
    toDate,
  ]);

  // useEffect(() => {
  //   if (!loading) {
  //     const metersData = getOr(null, "metersData", dashboardData);
  //     setData(metersData ? metersData : "");
  //   }
  // }, [dashboardData, loading]);

  return {
    data: data,
    loading,
  };
};
